import * as React from 'react';
import { RateSearchWidget } from '@bytebrand/fe-ui-core-autobahn/compat';
const RateSearchWidgetModal = ({ widgetProps }) => {
    return React.createElement(RateSearchWidget, { ...widgetProps });
};
export default RateSearchWidgetModal;
